import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const dateFormat = 'L LT';

class Recent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: ''
    };
    this.renderTable = this.renderTable.bind(this);
  }

  componentDidMount() {
    this.renderTable();
  }

  componentDidUpdate(prevProps, prevState) {
    const { orders } = this.props;
    if (prevProps.orders !== orders) {
      this.renderTable();
    }
  }

  renderTable() {
    const { orders } = this.props;
    let latestOrders;
    if (orders && orders.latest) {
      latestOrders = [...orders.latest].reverse();
    }

    if (latestOrders) {
      latestOrders.forEach((item, index, array) => {
        const latest = array;
        const prevItem = latest[index - 1];
        if (index === 0) {
          latest[index].trend = 'more';
        }
        if (prevItem) {
          if (latest[index].price > prevItem.price) {
            latest[index].trend = 'more';
          }
          if (latest[index].price < prevItem.price) {
            latest[index].trend = 'less';
          }
          if (latest[index].price === prevItem.price) {
            if (prevItem.trend === 'less') {
              latest[index].trend = 'less';
            }
            if (prevItem.trend === 'more') {
              latest[index].trend = 'more';
            }
          }
        }
      });
    }

    let tableData;
    if (latestOrders) {
      tableData = [...latestOrders].reverse();
    }
    this.setState({ tableData });
  }

  render() {
    const { exchA, exchB, orders, isOfType } = this.props;
    const { tableData } = this.state;

    let tableLoop;
    if (tableData) {
      tableLoop = tableData.map((trade, index) => {
        let priceColor;
        if (trade.trend === 'more') {
          priceColor = {
            color: 'rgb(78, 199, 138)',
          };
        }
        if (trade.trend === 'less') {
          priceColor = {
            color: 'rgb(255, 99, 51)',
          };
        }
        return (
          <tr key={index}>
            <td>{moment.unix(trade.createdAt).format(dateFormat)}</td>
            <td>{trade.quantity}</td>
            <td style={priceColor}>{trade.price}</td>
          </tr>
        );
      });
    }

    return (
      <div className="cell panel">
        <div className="panel-label">
          All Latest Trades
        </div>
        {orders && orders.latest ? (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Created At</th>
                  <th>Volume {isOfType(exchA) && '(grams)'}</th>
                  <th>Price ({exchB})</th>
                </tr>
              </thead>
              <tbody className="lt-body">
                {tableLoop}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <table>
              <thead>
                <tr>
                  <th>created At</th>
                  <th>Volume {isOfType(exchA) && '(grams)'}</th>
                  <th>Price ({exchB})</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
            <h3 style={{textAlign: 'center' }}>No Data</h3>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  errors: state.order.errors,
});

export default connect(mapStateToProps)(Recent);
